import React from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Label,
    Input,
    Button,
    Alert
} from "reactstrap";
import Select from "react-select";

const AddEditTeamModal = ({
    isOpen,
    toggle,
    editingTeam,
    setEditingTeam,
    users,
    selectedMemberIds,
    setSelectedMemberIds,
    handleSave,
    isSaving,
    done,
    error
}) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>
                {editingTeam?.id ? "Edit Team" : "Add Team"}
            </ModalHeader>

            <ModalBody>
                {error && <Alert color="danger">{error}</Alert>}

                <Form>
                    <FormGroup>
                        <Label>Team Name</Label>
                        <Input
                            value={editingTeam?.team_name || ""}
                            onChange={(e) =>
                                setEditingTeam({ ...editingTeam, team_name: e.target.value })
                            }
                        />
                    </FormGroup>

                    <FormGroup>
                        <Label>Team Leader</Label>
                        <Input
                            type="select"
                            value={editingTeam?.team_leader_id || ""}
                            onChange={(e) =>
                                setEditingTeam({ ...editingTeam, team_leader_id: e.target.value })
                            }
                        >
                            <option value="">Select</option>
                            {users.map((u) => (
                                <option key={u.id} value={u.id}>
                                    {u.full_name}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>

                    <FormGroup>
                        <Label>Team Members</Label>
                        <Select
                            isMulti
                            options={users
                                .filter(
                                    (u) =>
                                        u.id.toString() !==
                                        editingTeam?.team_leader_id?.toString()
                                )
                                .map((u) => ({
                                    value: u.id,
                                    label: u.full_name
                                }))
                            }
                            value={users
                                .filter((u) => selectedMemberIds.includes(u.id.toString()))
                                .map((u) => ({ value: u.id, label: u.full_name }))}
                            onChange={(opts) =>
                                setSelectedMemberIds(opts.map((o) => o.value.toString()))
                            }
                        />
                    </FormGroup>

                    <div className="text-end">
                        <Button color="success" onClick={handleSave} disabled={isSaving || done}>
                            {done
                                ? "Done"
                                : isSaving
                                    ? <span className="spinner-border spinner-border-sm me-1" />
                                    : "Save"}
                        </Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default AddEditTeamModal;